import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { regionFromPathname } from '../utils/regionFromPath';
import { localeFromRegion, t as translate } from '../i18n';

export function useI18n() {
  const { pathname } = useLocation();
  const region = regionFromPathname(pathname);
  const locale = useMemo(() => localeFromRegion(region), [region]);
  const t = (key, fallback = '') => translate(locale, key, fallback);
  return { locale, region, t };
}
